import { combineReducers } from "redux";
import torreMiniHub from "./slices/torreMiniHub.slice";

const reducer = combineReducers({
  torreMiniHub,
});

export default reducer;
